import { render, staticRenderFns } from "./ConceptForm.vue?vue&type=template&id=4c6fbf3d"
import script from "./ConceptForm.vue?vue&type=script&lang=js"
export * from "./ConceptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports